module.exports = __webpack_public_path__ + "tg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tg.svg
// module id = 1090
// module chunks = 0